import gql from 'graphql-tag';
import { TransactionFragment } from '../fragments/transaction.fragment';

export const CALCULATE_AGENT_POINT = gql`
    mutation(
        $input: CalculateAgentPointInput!
    ) {
        calculateAgentPoint (
            input: $input
        ) {
            ...TransactionInfo
        }
    }
    ${TransactionFragment}
`;